var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Status',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:(_vm.$props.showCompleteCircle && { content: _vm.$props.toolTipText, classes: 'status-popover' }),expression:"$props.showCompleteCircle && { content: $props.toolTipText, classes: 'status-popover' }",modifiers:{"bottom":true}}],staticClass:"status cursor-pointer",attrs:{"type":_vm.type}},[_vm._t("progress"),(_vm.$props.showCompleteCircle)?_c('div',{ref:"completed-trigger",staticClass:"mr-2 completed-trigger"},[[_c('CircleChart',{key:_vm.$props.status,staticClass:"mr-1 bt-d-flex",attrs:{"startAngle":180,"lineWidth":20,"size":12,"type":"full","data":[{
        value: 100 - _vm.$props.status,
        text: '',
        color: '#ffffff'
      },
      {
        value: _vm.$props.status,
        text: '',
        color: 'currentColor'
      }]}})],_vm._v(" Completed ")],2):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }